import { useEffect, useState } from 'react'
import { FiMonitor, FiMoon, FiSun } from 'react-icons/fi'
import { motion } from 'motion/react'
import { spring } from '../lib/springs'
import {
  THEME_EVENT,
  getThemeSetting,
  setTheme,
} from '../utility/theme'

/* ============================================================================
   Appearance control - three states, not a two-way switch.

   "System" is the default and keeps tracking the OS as it flips; Light and
   Dark pin the choice. A plain sun/moon toggle cannot express the difference
   between "I want light" and "my machine is light right now", which is the
   whole point of the setting, so this is a segmented control.

   It listens for app:theme rather than owning the state: theme.js also flips
   the mode when the OS changes underneath us, and the buttons have to follow.

   The active fill is one shared-layout pill that slides to the chosen
   segment rather than three backgrounds that swap.
   ========================================================================== */
const OPTIONS = [
  { value: 'system', label: 'System', Icon: FiMonitor },
  { value: 'light', label: 'Light', Icon: FiSun },
  { value: 'dark', label: 'Dark', Icon: FiMoon },
]

const ThemeToggle = () => {
  const [setting, setSetting] = useState(getThemeSetting)

  useEffect(() => {
    const onThemeChange = (e) => setSetting(e.detail.setting)
    window.addEventListener(THEME_EVENT, onThemeChange)
    return () => window.removeEventListener(THEME_EVENT, onThemeChange)
  }, [])

  return (
    <div className="theme-toggle">
      <div className="theme-toggle-label">Appearance</div>
      <div className="theme-toggle-group" role="group" aria-label="Appearance">
        {OPTIONS.map(({ value, label, Icon }) => (
          <button
            key={value}
            type="button"
            className={
              value === setting
                ? 'theme-toggle-btn is-active'
                : 'theme-toggle-btn'
            }
            aria-pressed={value === setting}
            onClick={(e) => setTheme(value, e.currentTarget)}
          >
            {value === setting ? (
              <motion.span
                layoutId="theme-toggle-pill"
                className="theme-toggle-pill"
                // a selection moving, not a hover: the tabs' moderate tier
                transition={spring.moderate}
                aria-hidden="true"
              />
            ) : null}
            <Icon aria-hidden="true" />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default ThemeToggle
